(function () {
  function getBundleFromElement(element) {
    return element ? element.closest('.container_pack_bundle') : null;
  }

  function isInsideQuickBuy(element) {
    return !!(element && element.closest('.quickbuy-container'));
  }

  function selectBundlePerle(variant) {
    const bundle = getBundleFromElement(variant);
    if (!bundle) return;

    const variants = bundle.querySelectorAll('.variant-selector .variant');
    const imageWrap = bundle.querySelector('#product-2-image');
    const titleEl = bundle.querySelector('#product-2-title');
    const dataIds = bundle.querySelector('#data-ids');

    variants.forEach(function (item) {
      item.classList.remove('selected');
    });

    variant.classList.add('selected');

    const image = variant.getAttribute('data-image');
    const title = variant.getAttribute('data-title');
    const id = variant.getAttribute('data-id');

    if (imageWrap && image) {
      imageWrap.innerHTML =
        '<img src="' + image + '" alt="' + (title || '') + '" width="80px" height="80px">';
    }

    if (titleEl && title) {
      titleEl.textContent = title;
    }

    if (dataIds) {
      if (id) dataIds.setAttribute('data-product_2_id', id);
      if (title) dataIds.setAttribute('data-product_2_title', title);
    }
  }

  function showMoreBundlePerles(button) {
    const bundle = getBundleFromElement(button);
    if (!bundle) return;

    bundle.querySelectorAll('.variant-selector .variant.hidden').forEach(function (variant) {
      variant.classList.remove('hidden');
    });

    button.style.display = 'none';
  }

  function dispatchCartEvents() {
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('on:cart:after-merge', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));

    document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.documentElement.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
    document.documentElement.dispatchEvent(new CustomEvent('on:cart:after-merge', { bubbles: true }));
    document.documentElement.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true }));
    document.documentElement.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
    document.documentElement.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
  }

  function getCartDrawerSectionElement() {
    return (
      document.querySelector('#shopify-section-sections--28433894015303__cart-drawer') ||
      document.querySelector('[id^="shopify-section-"][id*="cart-drawer"]') ||
      document.querySelector('[id^="shopify-section-"][id*="cart_drawer"]') ||
      document.querySelector('.section-cart-drawer') ||
      document.querySelector('cart-drawer')?.closest('[id^="shopify-section-"]')
    );
  }

  function getCartDrawerSectionIds() {
    const sectionEl = getCartDrawerSectionElement();
    const ids = [];

    if (sectionEl && sectionEl.id) {
      ids.push(sectionEl.id.replace('shopify-section-', ''));
    }

    ids.push('cart-drawer');

    return [...new Set(ids)];
  }

  function openCartDrawer() {
    const cartTrigger =
      document.querySelector('a[href="/cart"]') ||
      document.querySelector('a[href*="/cart"]') ||
      document.querySelector('[data-cart-drawer-toggle]') ||
      document.querySelector('[data-cart-toggle]') ||
      document.querySelector('.cart-link') ||
      document.querySelector('.header-cart');

    if (cartTrigger) {
      cartTrigger.click();
      return;
    }

    dispatchCartEvents();
  }

  function waitForCartItems(expectedCount, maxAttempts) {
    let attempts = 0;

    return new Promise(function (resolve) {
      function checkCart() {
        attempts += 1;

        fetch('/cart.js', {
          method: 'GET',
          headers: {
            Accept: 'application/json'
          }
        })
          .then(function (response) {
            return response.json();
          })
          .then(function (cart) {
            console.log('[bundle-perles] Wait cart:', cart.item_count, cart);

            if (cart.item_count >= expectedCount || attempts >= maxAttempts) {
              resolve(cart);
              return;
            }

            setTimeout(checkCart, 250);
          })
          .catch(function () {
            if (attempts >= maxAttempts) {
              resolve(null);
              return;
            }

            setTimeout(checkCart, 250);
          });
      }

      checkCart();
    });
  }

  function updateCartDrawerHtml(html) {
    const cartDrawerSection = getCartDrawerSectionElement();

    if (!cartDrawerSection || !html || typeof html !== 'string') {
      return false;
    }

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    const newSection =
      doc.querySelector('#' + cartDrawerSection.id) ||
      doc.querySelector('[id^="shopify-section-"][id*="cart-drawer"]') ||
      doc.querySelector('[id^="shopify-section-"][id*="cart_drawer"]') ||
      doc.querySelector('.section-cart-drawer') ||
      doc.body;

    if (!newSection) {
      return false;
    }

    cartDrawerSection.innerHTML = newSection.innerHTML || html;

    return true;
  }

  function refreshCartDrawerSection() {
    const sectionIds = getCartDrawerSectionIds();

    const requestUrl = '/?sections=' + sectionIds.map(encodeURIComponent).join(',');

    console.log('[bundle-perles] Refresh drawer request:', requestUrl);

    return fetch(requestUrl, {
      method: 'GET',
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Impossible de recharger les sections du panier');
        }

        return response.json();
      })
      .then(function (sections) {
        console.log('[bundle-perles] Sections reçues:', sections);

        let refreshed = false;

        sectionIds.forEach(function (sectionId) {
          if (refreshed) return;

          const html = sections && sections[sectionId];

          if (html) {
            refreshed = updateCartDrawerHtml(html);
          }
        });

        if (!refreshed && sections && sections['cart-drawer']) {
          refreshed = updateCartDrawerHtml(sections['cart-drawer']);
        }

        if (!refreshed) {
          console.warn('[bundle-perles] Impossible de remplacer le HTML du drawer.');
        }

        dispatchCartEvents();

        return refreshed;
      })
      .catch(function (error) {
        console.warn('[bundle-perles] Refresh cart drawer échoué:', error);
        dispatchCartEvents();
        return false;
      });
  }

  function addBundleToCartFromQuickBuy(button) {
    const bundle = button.closest('.container_pack_bundle');
    const dataIds = bundle ? bundle.querySelector('#data-ids') : null;

    if (!bundle || !dataIds) {
      console.error('[bundle-perles] data-ids introuvable');
      alert("Impossible d'ajouter le coffret : données produit introuvables.");
      return;
    }

    const product1Id = dataIds.getAttribute('data-product_1_id');
    const product2Id = dataIds.getAttribute('data-product_2_id');

    const product1Title = dataIds.getAttribute('data-product_1_title') || '';
    const product2Title = dataIds.getAttribute('data-product_2_title') || '';

    const coffretProperty = product1Title + ' & ' + product2Title;

    console.log('[bundle-perles] QuickBuy - IDs envoyés au panier:', {
      product1Id: product1Id,
      product2Id: product2Id,
      coffret: coffretProperty
    });

    if (!product1Id || !product2Id) {
      console.error('[bundle-perles] variant ID manquant', {
        product1Id: product1Id,
        product2Id: product2Id
      });

      alert("Impossible d'ajouter le coffret : variante manquante.");
      return;
    }

    const originalText = button.textContent;

    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');
    button.textContent = 'AJOUT EN COURS...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(product1Id),
            quantity: 1,
            properties: {
              coffret: coffretProperty
            }
          },
          {
            id: Number(product2Id),
            quantity: 1,
            properties: {
              coffret: coffretProperty
            }
          }
        ]
      })
    })
      .then(function (response) {
        console.log('[bundle-perles] /cart/add.js status:', response.status);

        if (!response.ok) {
          return response.json().then(function (error) {
            throw error;
          });
        }

        return response.json();
      })
      .then(function (addData) {
        console.log('[bundle-perles] Ajout panier réussi:', addData);

        button.textContent = 'COFFRET AJOUTÉ ✓';

        return waitForCartItems(2, 12);
      })
      .then(function (cart) {
        console.log('[bundle-perles] Panier confirmé:', cart);

        return refreshCartDrawerSection();
      })
      .then(function () {
        setTimeout(function () {
          dispatchCartEvents();
        }, 300);

        setTimeout(function () {
          refreshCartDrawerSection().then(function () {
            dispatchCartEvents();
            openCartDrawer();
          });
        }, 1200);

        setTimeout(function () {
          button.disabled = false;
          button.setAttribute('aria-disabled', 'false');
          button.textContent = originalText || 'AJOUTER MON COFFRET';
        }, 1800);
      })
      .catch(function (error) {
        console.error('[bundle-perles] Erreur ajout panier:', error);

        button.disabled = false;
        button.setAttribute('aria-disabled', 'false');
        button.textContent = originalText || 'AJOUTER MON COFFRET';

        alert("Impossible d'ajouter le coffret au panier. Regarde la console pour l'erreur exacte.");
      });
  }

  document.addEventListener(
    'click',
    function (event) {
      const variant = event.target.closest('.container_pack_bundle .variant-selector .variant');
      const showMore = event.target.closest('.container_pack_bundle #show_more');
      const addButton = event.target.closest('.container_pack_bundle .bundle-add-to-cart');

      if (variant) {
        event.preventDefault();
        event.stopPropagation();

        selectBundlePerle(variant);
        return;
      }

      if (showMore) {
        event.preventDefault();
        event.stopPropagation();

        showMoreBundlePerles(showMore);
        return;
      }

      if (addButton) {
        if (!isInsideQuickBuy(addButton)) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();

        addBundleToCartFromQuickBuy(addButton);
        return;
      }
    },
    true
  );
})();